import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Colores corporativos Santander + variantes
const colors = {
  info: { bg: "#ec0000", text: "#ffffff" }, // Rojo Santander
  success: { bg: "#28a745", text: "#ffffff" },
  warning: { bg: "#ffc107", text: "#333333" },
  error: { bg: "#dc3545", text: "#ffffff" },
};

// Estilos base
const baseStyle = {
  position: "fixed",
  top: "-100px", // posición inicial fuera de pantalla
  left: "50%",
  transform: "translateX(-50%)",
  padding: "12px 16px",
  borderRadius: "6px",
  fontFamily: "Arial, sans-serif",
  fontSize: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  minWidth: "280px",
  zIndex: 9999,
  transition: "top 0.4s ease-in-out",
};

const closeButtonStyle = {
  background: "transparent",
  border: "none",
  color: "inherit",
  fontSize: "16px",
  cursor: "pointer",
  lineHeight: "1",
};

const Alert = ({ type = "info", message, onClose, duration = 3000 }) => {
  const [visible, setVisible] = useState(false);

  // Mostrar alerta con animación
  useEffect(() => {
    setVisible(true);

    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 400); // esperar animación
  };

  const { bg, text } = colors[type] || colors.info;

  return (
    <div
      style={{
        ...baseStyle,
        backgroundColor: bg,
        color: text,
        top: visible ? "20px" : "-100px", // animación
      }}
    >
      <span>{message}</span>
      <button
        style={closeButtonStyle}
        onClick={handleClose}
        aria-label="Cerrar alerta"
      >
        ×
      </button>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(["info", "success", "warning", "error"]),
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  duration: PropTypes.number,
};

export default Alert;
